import { GridColDef, GridColumnHeaderParams } from '@mui/x-data-grid-premium'
import { Typography } from '@mui/material'
import { TableCell, theme } from '@ketch-com/deck'

interface JurisdictionStat {
  policyScopeCode: string
  policyScopeName?: string | null
  complete: number
  rejected?: number
  fulfilledOnTime: number
  meanFulfillmentTime?: number
}

interface JurisdictionRow {
  id: string
  jurisdiction: string
  complete: number
  rejected: number
  fulfilledOnTime: number
  meanFulfillmentTime: number
}

export const transformJurisdictionDataToRows = (data: JurisdictionStat[]): JurisdictionRow[] => {
  return data.map((item, i) => ({
    id: `${item.policyScopeCode}-${i}`,
    jurisdiction: item.policyScopeName || item.policyScopeCode,
    complete: item.complete,
    rejected: item.rejected ?? 0,
    fulfilledOnTime: item.fulfilledOnTime,
    meanFulfillmentTime: item.meanFulfillmentTime ?? 0,
  }))
}

export const jurisdictionDataGridColumns: GridColDef<JurisdictionRow>[] = [
  {
    field: 'jurisdiction',
    headerName: 'Jurisdiction',
    flex: 2,
    renderHeader: (params: GridColumnHeaderParams<JurisdictionRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Jurisdiction
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="label">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    field: 'complete',
    headerName: 'Complete',
    flex: 0.9,
    type: 'number',
    renderHeader: () => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Complete
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    field: 'rejected',
    headerName: 'Rejected',
    flex: 0.9,
    type: 'number',
    renderHeader: () => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Rejected
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    field: 'fulfilledOnTime',
    headerName: 'Fulfilled On Time',
    flex: 1.5,
    type: 'number',
    renderHeader: () => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Fulfilled On Time
      </Typography>
    ),
    renderCell: params => {
      const fulfilledOnTime = Number(params.row.fulfilledOnTime)
      const complete = Number(params.row.complete)
      const percentage =
        complete > 0 && !isNaN(fulfilledOnTime) ? Math.min(Math.round((fulfilledOnTime / complete) * 100), 100) : 0

      return (
        <TableCell>
          <Typography variant="body">{percentage}%</Typography>
        </TableCell>
      )
    },
  },
  {
    field: 'meanFulfillmentTime',
    headerName: 'Mean Fulfillment Time',
    flex: 1.5,
    type: 'number',
    renderHeader: () => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Mean Fulfillment Time
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value} days</Typography>
      </TableCell>
    ),
  },
]
